import { Component, inject, signal, effect } from '@angular/core';
import { IonApp, IonRouterOutlet } from "@ionic/angular/standalone";
import { TranslateService } from '@ngx-translate/core';
import { DataContext } from '@services/data-context';
import { ViewportService } from '@services';
import { LanguageService } from '@services/language';

@Component({
  selector: 'app-root',
  imports: [IonApp, IonRouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  host: {
    '(window:resize)': 'onWindowResize()'
  }
})
export class App {
  protected readonly title = signal('MicrobuildManagementClient');
  private readonly translate = inject(TranslateService);
  private readonly dataContext = inject(DataContext);
  private readonly viewportService = inject(ViewportService);
  private readonly languageService = inject(LanguageService);

  constructor() {
    // Set default language and supported languages
    this.translate.addLangs(['no', 'se', 'en', 'da']);
    this.translate.setFallbackLang('no');
    // Use the last-known language so pre-login screens (e.g. auth-callback)
    // render in the user's language instead of always defaulting to Norwegian.
    this.translate.use(this.languageService.getStoredLanguage());

    // Watch for user changes and update language
    effect(() => {
      const user = this.dataContext.loggedInUser();
      if (user?.language) {
        this.translate.use(user.language);
        this.languageService.setStoredLanguage(user.language);
      }
    });
  }

  protected onWindowResize(): void {
    if (globalThis.window === undefined) {
      return;
    }
    this.viewportService.updateWidth(globalThis.window.innerWidth);
  }
}
